import React, { useCallback, useEffect, useState } from 'react'
import FilterComponent from '../../../core/common/FilterComponent'
import Ribbon from '../../../core/common/ribbon/ribbon'
import { Link, useNavigate } from 'react-router-dom'
import { svgIcons } from '../../../style/fonts/SvgIcons'
import TextField from '../../../core/common/textFields/TextField'
import TableHeading from '../../../core/common/tableHeading/TableHeading'
import { useGetAllAccountsQuery } from '../../../services/EndPointsApis'
import { useTableSelection } from '../../../core/hooks/useTableSelection'
import NoRecordFound from '../../../core/common/noRecord/NoRecordFound'
import TableLoading from '../../../core/common/loadingComponent/TableLoading'
import { debounce } from 'lodash';
import FilterModalUser from '../manageUsers/FilterModalUser'
import Pagination from '../../../core/common/pagination/Pagination'
import ManageColumnAccounts from './ManageColumnAccount/ManageColumnAccounts'
import { initialColumnAccount } from './ManageColumnAccount/InitialColumns'
import { CSVLink } from 'react-csv'
import dayjs from "dayjs";

const Accounts = () => {
  const formattedDate = dayjs().format("YYYY-MM-DD_HH-mm-ss");

  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(15);
  const [searchStr, setSearchStr] = useState('');
  const [sortBy, setSortBy] = useState("createDT");
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedColumn, setSortedColumn] = useState("createDT");
  const [immediateSearchStr, setImmediateSearchStr] = useState('')

  //get All Accounts
  const { data: allAccounts, refetch: refetchAccounts, isLoading } = useGetAllAccountsQuery({
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr || '',
    sortBy: sortBy,
    sortOrder: sortOrder,
  });
  const { data: allAccountsCSv } = useGetAllAccountsQuery({
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr || '',
    sortBy: sortBy,
    sortOrder: sortOrder,
  });
  //pagination and sorting 

  const handlePageSizeChange = (selectedOption: any) => {
    setPageSize(selectedOption.value);
    setPageNumber(1);
  };
  // pagination
  const handlePageClick = (e: any) => {
    setPageNumber(e.selected + 1);
  };
  //per page record
  const handlePageRecords = (e: any) => {
    setPageNumber(1);
  };

  const handleSort = (property: string) => {
    setSortBy(property);
    if (sortedColumn === property) {
      setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortedColumn(property);
      setSortOrder("asc");
    }
  };

  const idValue = 'dropdownMenuClickableInsise1';
  const handlefiltermodel = () => {
    setShowfilterModal(true);
    const dropdownToggle = document.getElementById(idValue);
    if (dropdownToggle) {
      dropdownToggle.click();
    }
  }

  const handleSearchChange = (e: any) => {
    const { value } = e.target;
    setImmediateSearchStr(value); // Update immediate search state
    delayedSearch(value); // Update debounced search state
  };
  const delayedSearch = useCallback(
    debounce((searchValue) => {
      setSearchStr(searchValue);
    }, 500),
    []
  );
  useEffect(() => {
    if (searchStr === "" ||
      sortOrder === "" ||
      sortBy === "") {
      refetchAccounts();
    }
  }, [searchStr, sortOrder, sortBy]);

  //Pagination and sorting 
  useEffect(() => {
    refetchAccounts()
  }, [refetchAccounts])


  const {
    isTableHeadChecked,
    selectedIndividualCheckboxId,
    selectedItemData: contactData,
    handleTableHeadChange,
    handleCheckItem,
    handleRowClick,
    handleRowDoubleClick
  } = useTableSelection(allAccounts?.result?.data || [], 'accountId');

  const navigate = useNavigate();
  const [showfilterModal, setShowfilterModal] = useState(false);
  const [accountId, setAccountId] = useState()
  const handleAddContact = () => {
    navigate('/accounts/AddAccounts')
  }
  const handleEditContacts = () => {
    navigate(`/accounts/EditAccounts/${selectedIndividualCheckboxId}`)
  }
  const handleViewDetails = () => {
    navigate(`/accounts/acccountDetails/${selectedIndividualCheckboxId}`)
  }

  const [viewOnly, setViewOnly] = useState(false)
  const isAnyCheckboxChecked = selectedIndividualCheckboxId.length > 0;
  const isMoreThanOneChecked = selectedIndividualCheckboxId.length > 1;

  // Change the state to force re-render
  const handleReload = () => {
    refetchAccounts()
  };

  const items = [
    // {
    //   label: 'Edit',
    //   tooltipLabel: 'Edit',
    //   icon: svgIcons.updateIcon,
    //   onClick: () => handleEditContacts(),
    //   disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked,
    //   disableIcon: svgIcons.updateIcon
    // },
    {
      label: 'View Details',
      tooltipLabel: "View details",
      icon: svgIcons.eyeIcon,
      onClick: () => handleViewDetails(),
      disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked, disableIcon: svgIcons.eyeIcon,
    },
    { label: 'Refresh', tooltipLabel: "Refresh", icon: <i className="ti ti-refresh-dot" aria-hidden="true"></i>, onClick: handleReload, }

  ];

  const handleDoubleClick = (items: any) => {
    handleRowDoubleClick(items);
    // dispatch(setContactsData(items))
    navigate(`/accounts/acccountDetails/${items.accountId}`)
  };
  const handleClosefilterModal = () => {
    setShowfilterModal(false)
  };
  //Manage columns
  const [visibleColumns, setVisibleColumns] = useState(() => {
    const savedColumns = localStorage.getItem('columnSettingsAccounts');
    return savedColumns
      ? JSON.parse(savedColumns)
      : initialColumnAccount.reduce((acc, column) => ({ ...acc, [column.id]: column.checked }), {});
  });
  const handleColumnToggle = (updatedColumns: any) => {
    setVisibleColumns(updatedColumns);
    localStorage.setItem('columnSettingsAccounts', JSON.stringify(updatedColumns));
  }
  // csv data 
  const headers = initialColumnAccount.map(item => ({
    label: item.name,
    key: item.key,
  }));

  const CsvData = allAccountsCSv?.result?.data?.map((record: Record<string, any>) => {
    const csvRecord: Record<string, any> = {};
    headers?.forEach(header => {
      csvRecord[header.key] = record[header.key]?.value ?? record[header.key] ?? "";
    });
    return csvRecord;
  }) || []
  return (
    <>
      <FilterModalUser show={showfilterModal} handleClose={handleClosefilterModal} />
      <div className="page-wrapper">
        <div className="content">
          <div className="row ">
            <div className="col-md-12">
              <Ribbon
                items={items}
                buttonText="+ Add New"
                buttonClass="add-popup ribbon-btn "
                onClickbtn={() => handleAddContact()}
                // buttonText2='Share'
                // Icon={svgIcons.shareIcon}
              // disabled={isAnyCheckboxChecked || isMoreThanOneChecked}
              />
              {/* /Page Header */}
              <div className="card main-card">
                <div className="card-body">
                  {/* Search */}
                  <div className="search-section">
                    <div className="row align-items-center">
                      <div className="col-md-4 col-sm-8 mb-2">
                        <h4 className="page-title color-red">Accounts</h4>
                      </div>
                      <div className="col-md-8 mb-2">
                        <div className='d-flex gap-2 flex-md-row flex-column justify-content-end'>
                          <CSVLink data={CsvData} headers={headers} filename={`Account_List ${formattedDate}.csv`} className="btn btn-light-red d-flex gap-1 align-items-center justify-content-center">
                            <i className="fa fa-file-export" />
                            Export To CSV
                          </CSVLink>
                          <FilterComponent handlefiltermodel={handlefiltermodel} idValue={idValue} />
                          <ManageColumnAccounts columns={initialColumnAccount} visibleColumns={visibleColumns} onColumnToggle={handleColumnToggle} />

                          <div>
                            <div className=" icon-form">
                              <span className="form-icon">
                                <i className="ti ti-search" />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search Account"
                                onChange={handleSearchChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive custom-table">
                        <table className="table datanew dataTable no-footer table-hover">
                          <thead>
                            <tr>
                              <th>
                                {/* <input
                                  type="checkbox"
                                  className='form-check-input cursor-pointer'
                                // checked={isTableHeadChecked}
                                // onChange={handleTableHeadChange}
                                /> */}
                              </th>
                              {initialColumnAccount.map((column) => (
                                visibleColumns[column.id] &&

                                <TableHeading
                                  label={column.name}
                                  sortedColumn={column.name}
                                  columnId={column.name}
                                  sortOrder='desc'
                                  handleSort={() => handleSort(column?.key)}
                                />

                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {!isLoading && <>
                              {allAccounts?.result?.data?.length > 0 ? (
                                <>
                                  {allAccounts?.result?.data?.map((data: any, index: any) => {
                                    return (
                                      <tr key={data?.accountId} onClick={() => handleRowClick(data)} onDoubleClick={() => handleDoubleClick(data)}
                                        className={selectedIndividualCheckboxId.includes(data.contactId) ? 'selected-row' : ''}>
                                        <td>
                                          <div className='d-flex gap-2'>
                                            <TextField
                                              type="checkbox"
                                              fieldClass='form-check-input cursor-pointer'
                                              checked={isTableHeadChecked || selectedIndividualCheckboxId.includes(data.accountId)}
                                              onChange={(e) => handleCheckItem(e, data)}
                                            />
                                            <Link to={`/accounts/EditAccounts/${data?.accountId}`}
                                            >
                                              {svgIcons.updateIcon}
                                            </Link>
                                          </div>
                                        </td>
                                        {/* <td>{data?.accountName}</td>
                                      <td>{data?.phone}</td>
                                      <td>{data?.lst_PrimaryContact?.value}</td>
                                      <td>{data?.email}</td>
                                      <td> {data?.status !== true ? (
                                        <span className="badge badge-pill badge-status bg-soft-success text-success">Active</span>
                                      ) : (
                                        <span className="badge badge-pill badge-status bg-soft-danger text-danger">Inactive</span>
                                      )}
                                      </td> */}
                                        {initialColumnAccount.map((column) => (
                                          visibleColumns[column.id] && (
                                            <td key={column.id}>
                                              {
                                                column.key === 'isActive' ? (
                                                  data[column.key] === true ? (
                                                    <span className="badge badge-pill badge-status bg-soft-success text-success">Active</span>
                                                  ) : data[column.key] === false ? (
                                                    <span className="badge badge-pill badge-status bg-soft-danger text-danger">Inactive</span>
                                                  ) : (
                                                    <span className="badge badge-pill badge-status bg-soft-gray text-muted">None</span>
                                                  )
                                                )
                                                  : data[column.key] !== undefined && data[column.key] !== null
                                                    ? typeof data[column.key] === 'object' && data[column.key] !== null
                                                      ? data[column.key].value !== undefined
                                                        ? (
                                                          data[column.key].value
                                                        )
                                                        : ''
                                                      : data[column.key]
                                                    : ''}
                                            </td>
                                          )
                                        ))}
                                      </tr>
                                    )
                                  })}
                                </>
                              ) :
                                (<tr>
                                  <td colSpan={7}>
                                    <NoRecordFound />
                                  </td>
                                </tr>)}
                            </>
                            }
                            {isLoading &&
                              <TableLoading />
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <Pagination
                    // totalResult={allUsers?.result?.value?.result?.totalRecords === 0 ? 0 : ((allUsers?.result?.value?.result?.pageNumber - 1) * allUsers?.result?.value?.result?.pageSize) + 1}
                    // toResult={allUsers?.result?.value?.result?.totalRecords === 0 ? 0 : Math.min(allUsers?.result?.value?.result?.pageNumber * allUsers?.result?.value?.result?.pageSize, allUsers?.result?.value?.result?.totalRecords)}
                    // ofResult={allUsers?.result?.value?.result?.totalRecords}
                    onChange={handlePageSizeChange}
                    pageSize={pageSize}
                    onPageChange={handlePageClick}
                    pageCount={allAccounts?.result?.totalPages || 0}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Accounts